import http from "@/utils/http";


export const SpaceApi = {
    getNotAllotDmsDeviceList(data){
        return http.post(`/server/dmsSpace/selectNotAllotDmsDeviceList`,data)
    },
    getSpaceDmsDeviceList(data){
        return http.post(`/server/dmsSpace/selectSpaceDmsDeviceList`,data)
    },
    getSpaceDmsDevicePage(params){
        return http.get(`/server/dmsSpace/devicePage`,params)
    },
    getSpaceList(params) {
        return http.get(`/server/dmsSpace/list`,params)
    },
    allotDevice(data){
        return http.post(`/server/dmsSpace/allotDevice`,data)
    },
    deleteDevice(data){
        return http.post(`/server/dmsSpace/deleteDevice`,data)
    },
    save(data){
        return http.post(`/server/dmsSpace/save`,data)
    },
    deleteById(id) {
        return http.get(`/server/dmsSpace/delete/${id}`)
    },
}